export class NameUtils {
    public static getName(value: { firstName?: string; lastName?: string }, emptyAs = ''): string {
        if (!value || (!value.firstName && !value.lastName)) return emptyAs;
        if (!value.lastName) return value.firstName;
        if (!value.firstName) return value.lastName;
        return `${value.firstName} ${value.lastName}`;
    }
}
